<script lang="ts">
    // Icons
    import AllPlaylistIcon from '~assets/icons/navigation_all_playlists.svg';
    import AlbumIcon from '~assets/icons/albums.svg';
    import ArtistIcon from '~assets/icons/artists.svg';
    import ComposerIcon from '~assets/icons/composers.svg';
    import RecordingIcon from '~assets/icons/recordings.svg';
    import SearchIcon from '~assets/icons/sidebar-search.svg';
    import TrackIcon from '~assets/icons/tracks.svg';
    import WorkIcon from '~assets/icons/works.svg';
    import type { Page } from '~/jet/models';
    import type { ComponentType } from 'svelte';

    export let page: Page;

    $: emptyPageSection = page.sections[0];

    const ICON_MAP: Record<string, ComponentType> = {
        album: AlbumIcon,
        artist: ArtistIcon,
        composer: ComposerIcon,
        playlist: AllPlaylistIcon,
        recording: RecordingIcon,
        search: SearchIcon,
        track: TrackIcon,
        work: WorkIcon,
    };

    const handleBrowseClick = () => {};
</script>

<div role="status" class="error-content">
    <div class="error-content__icon">
        <svelte:component this={ICON_MAP[emptyPageSection.icon]} />
    </div>
    <h2
        data-testid="header"
        class="error-content__header typography-headline-emphasized"
    >
        {emptyPageSection.heading}
    </h2>
    <p
        data-testid="error-desc"
        class="error-content__description typography-subhead"
    >
        {emptyPageSection.description}
    </p>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/mixins/absolute-center' as *;

    .error-content {
        height: 166px;
        max-width: 440px;
        padding: 0 25px;
        color: var(--systemSecondary);
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @include absolute-center;
    }

    .error-content__header {
        font: var(--title-2-emphasized-serif);
    }

    .error-content__description {
        margin-top: 3px;
        margin-bottom: 15px;
        font: var(--title-3-tall);
    }

    .error-content__icon {
        :global(svg) {
            margin-bottom: 24px;
            width: 70px;
            height: auto;
            fill: var(--systemSecondary);
        }
    }

    .button-container {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
